import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, object = logged in

  useEffect(() => {
    const token = localStorage.getItem("gb_token");
    if (!token) { setUser(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem("gb_token");
      setUser(false);
    });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("gb_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("gb_token");
    setUser(false);
  };

  const applyAuth = (data) => {
    if (data?.token) localStorage.setItem("gb_token", data.token);
    if (data?.user) setUser(data.user);
  };

  return <AuthContext.Provider value={{ user, login, logout, applyAuth }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
